import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import { SimpleGallery, Uploader } from '../uploads'
import settings from '../settings'
import { allowedExtensions } from '../../../utils/cloudinary'
import useTranslation from '../../../utils/translation'

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: ${theme('photoUpload.section.borderBottom')};
  padding: ${theme('photoUpload.section.padding')};

  ${(props) => props.theme.media.min.sm`
    flex-direction: row;
  `}
`

const Right = styled.div`
  text-align: right;
  display: flex;
  flex-direction: column;
  margin-top: 14px;
  ${(props) => props.theme.media.min.sm`
    min-width: 370px;
  `}
  ${(props) => props.theme.media.min.lg`
    margin-top: 0;
  `}
`

const UploadContainer = styled.div`
  width: 100%;
  max-width: 370px;
  padding: ${theme('photoUpload.container.padding')};

  label {
    padding: ${theme('photoUpload.button.padding')};
    color: ${theme('photoUpload.button.color')};
    font-size: ${theme('photoUpload.button.fontSize')};
    letter-spacing: ${theme('photoUpload.button.letterSpacing')};

    &:before {
      color: ${theme('photoUpload.button.color')};
      background-color: ${theme('photoUpload.button.backgroundColor')};
      border: ${theme('photoUpload.button.border')};
      height: ${theme('photoUpload.button.height')};
    }

    &:not([disabled]):hover {
      color: ${theme('photoUpload.buttonHover.color')};

      &:before {
        color: ${theme('photoUpload.buttonHover.color')};
        background-color: ${theme('photoUpload.buttonHover.backgroundColor')};
        border: ${theme('photoUpload.buttonHover.border')};
      }
    }
  }
  ${(props) => props.theme.media.min.sm`
    max-width: 270px;
    margin-left: ${theme('photoUpload.container.marginLeft')};
  `}
  ${(props) => props.theme.media.min.md`
    max-width: 370px;
  `}
`

const PhotoUpload = ({ fileInputId, onChange, uploadedFiles }) => {
  const t = useTranslation('app.prep-form')

  return (
    <SectionWrapper>
      <Right>
        <UploadContainer data-track="upload-container">
          <Uploader
            {...settings.uploads}
            userId="bada"
            handleChange={onChange}
            initialFiles={uploadedFiles}
            allowedExtensions={allowedExtensions}
            render={(uploaderProps) => (
              <SimpleGallery
                {...uploaderProps}
                fileInputId={fileInputId}
                fileInputText={`+ ${t('upload-button', '')}`}
              />
            )}
          />
        </UploadContainer>
      </Right>
    </SectionWrapper>
  )
}

PhotoUpload.propTypes = {
  fileInputId: PropTypes.string.isRequired,
  uploadedFiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default PhotoUpload
